import { render } from "./AddPartToCartModal.vue?vue&type=template&id=5e610f24&scoped=true&bindings={}"
import script from "./AddPartToCartModal.vue?vue&type=script&lang=ts"
export * from "./AddPartToCartModal.vue?vue&type=script&lang=ts"

import "./AddPartToCartModal.vue?vue&type=style&index=0&id=5e610f24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e610f24"

export default script